import React, { useState } from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import { Link } from 'react-router-dom';
import { useSearchParam } from 'react-use';

import { REDIRECT_NOTE_SEARCH_KEY } from 'utils/AuthUtils';

import './AuthRedirectToast.scss';

export const AuthRedirectToast = () => {
  const redirectedFrom = useSearchParam(REDIRECT_NOTE_SEARCH_KEY);
  const [open, setOpen] = useState(Boolean(redirectedFrom));

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen?.(false);
  };

  return (
    <Snackbar
      open={open}
      className="toastRedirect"
      onClose={handleClose}
      onClick={() => {
        handleClose();
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={4000}
      message="Sie wurden automatisch auf eine vorher besuchte Seite umgeleitet."
      action={redirectedFrom && <Link to={redirectedFrom}>Zurück zur Startseite</Link>}
    />
  );
};
